
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.459","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M0 7.189c.018-.067.037-.129.055-.2a1.926 1.926 0 011.6-1.483 1.87 1.87 0 012 .87 1.925 1.925 0 01-.018 2.218c-.031.049-.067.1-.123.178 1.042.533 2.077 1.06 3.131 1.6a7387.9 7387.9 0 013.86-6.739 2 2 0 01-.827-1.875 1.887 1.887 0 01.717-1.311 2 2 0 012.763.227 2.024 2.024 0 01-.374 2.978 2116.96 2116.96 0 013.854 6.721c1.1-.558 2.175-1.109 3.259-1.666a2.029 2.029 0 01-.386-1.593 1.968 1.968 0 011.912-1.63A1.991 1.991 0 0123.4 6.999c.018.067.037.129.055.2v.551c-.018.049-.031.1-.049.153a1.944 1.944 0 01-1.538 1.519.268.268 0 00-.239.263q-.349 2.031-.7 4.056c-.1.613-.214 1.225-.325 1.844a1.5 1.5 0 01-.153.006q-3.308 0-6.617.006a.287.287 0 01-.27-.159c-.594-.968-1.195-1.936-1.789-2.9-.043-.067-.092-.135-.147-.221a2.33 2.33 0 00-.135.208c-.588.956-1.182 1.905-1.764 2.867a.38.38 0 01-.374.214q-3.217-.009-6.433-.006h-.263c-.08-.46-.159-.9-.233-1.342-.263-1.532-.533-3.063-.79-4.6a.312.312 0 00-.257-.288 1.836 1.836 0 01-1.152-.98A5.611 5.611 0 010 7.753v-.564zM2.818 16.636h1.881c1.556 0 3.118.006 4.675-.006a.373.373 0 01.361.208c.582.956 1.176 1.912 1.765 2.867.043.067.092.135.147.221l.141-.2 1.8-2.922a.277.277 0 01.263-.165q3.244.009 6.482.006c.037 0 .074.006.135.006v3.351H2.824c-.006-1.123-.006-2.232-.006-3.366z"}}),_c('path',{staticClass:"a",attrs:{"d":"M11.637 14.762c.282.459.545.876.8 1.3a.157.157 0 01.006.147c-.257.429-.521.852-.809 1.311a99.59 99.59 0 01-.8-1.3.2.2 0 01.012-.165c.256-.429.513-.84.791-1.293z"}})])
          )
        }
      }
    